import React, {useState, useEffect} from "react"

export default function RadioCustom({name, value, label, checked})
{     
    const [fieldStatus , setFieldStatus] = useState(checked)
    const [fieldClass, setFieldClass] = useState(checked === true ? 'stylized-radio checked' :'stylized-radio')

    const toggleStatus = (e) =>
    {
        setFieldStatus(!fieldStatus)
        toggleClass(e)
    }

    const toggleClass = (target) =>
    {
        const targets = document.getElementsByName(name)        
        
        for (let i = 0; i < targets.length; i++) 
        {            
            targets[i].parentElement.classList.remove('checked')            
        }
        
        if(target.currentTarget.classList.contains('checked'))
        {
            target.currentTarget.classList.remove('checked')
            return
        }

        target.currentTarget.classList.add('checked')
    }
    
    return (
        <div className={fieldClass} onClick={toggleStatus}>
            <input className={'input_'+name} type="radio" name={name} value={value} checked={fieldStatus} /><div className="label">{label}</div>
        </div>    
    ) 
}